<div class="dialog-wrapper content-creation">
  <h2 *ngIf="isNewPost" mat-dialog-title>
    {{ "brand.campaign.contentCalendarCarouselPost.createTitle" | translate }}
  </h2>
  <h2 *ngIf="!isNewPost" mat-dialog-title>
    {{ "brand.campaign.contentCalendarCarouselPost.updateTitle" | translate }}
  </h2>
  <mat-dialog-content>
    <form>
      <section class="upload-image">
        <h3 class="upload-image__title">
          {{
            "brand.campaign.contentCalendarCarouselPost.carouselImages"
              | translate
          }}
          <app-tooltip
            text="{{
              'brand.campaign.contentCalendarCarouselPost.uploadMediaTitle'
                | translate
            }}"
          />
        </h3>
        <ng-container *ngIf="post.carouselSlides?.length > 0">
          <div class="preview-container">
            <app-carousel-preview
              #carouselPreview
              (itemSelected)="onThumbnailSelected($event)"
              [itemSizePx]="72"
              [numVisibleItems]="5"
            >
              <div
                carouselItem
                *ngFor="let item of post.carouselSlides"
                [image]="'url(' + item.url + ')'"
                [videoUrl]="item.videoUrl"
                [fileType]="item.fileType"
                [file]="item"
                [id]="item.id"
              ></div>
            </app-carousel-preview>
            <app-file-uploader
              *ngIf="canUploadMoreFiles() && post.carouselSlides?.length > 0"
              [uploadHtmlTemplate]="uploaderHtmlTemplate"
              [uploadUrl]="uploaderCarouselUrl"
              (apiResponse)="handleUploadCarouselResponse($event)"
              (uploadError)="fileUploaderErrorHandler($event)"
              [responseMapper]="fileUploaderResponseMapper"
            />
          </div>
          <app-carousel-edit
            #carouselEdition
            [slides]="post.carouselSlides"
            (deleteItem)="onActionDeleteItem($event)"
          />
        </ng-container>
        <app-file-uploader
          *ngIf="canUploadMoreFiles() && post.carouselSlides?.length === 0"
          [uploaderTitle]="
            'brand.campaign.contentCalendarCarouselPost.dragAndDropText'
              | translate
          "
          [uploaderSubtitle]="uploaderCarouselSubtitle"
          [uploadUrl]="uploaderCarouselUrl"
          (fileAddedToQueue)="imageSelected($event)"
          (apiResponse)="handleUploadCarouselResponse($event)"
          (uploadError)="fileUploaderErrorHandler($event)"
          [responseMapper]="fileUploaderResponseMapper"
        />
      </section>
      <app-brand-campaign-content-form-post-suggested-text
        *ngIf="postTags"
        #suggestedText
        [text]="post.text"
        [postTags]="postTags"
        [type]="campaign.type"
        (textChanged)="onTextChanged($event)"
      />

      <app-brand-campaign-content-form-fb-landing-page-url [post]="post" />

      <section class="channels">
        <h3 class="channels-title">
          {{ "brand.campaign.contentCalendarPost.chooseChannels" | translate }}
          <app-tooltip
            text="{{
              'brand.campaign.contentCalendarPost.chooseChannelsToolTip'
                | translate
            }}"
          />
        </h3>
        <mat-checkbox
          class="channels-checkbox"
          name="facebookPlatform"
          [(ngModel)]="post.postToFacebook"
        >
          Facebook
        </mat-checkbox>
        <mat-checkbox
          class="channels-checkbox channels-checkbox--right"
          name="instagramPlatform"
          [disabled]="true"
          [(ngModel)]="post.postToInstagram"
        >
          Instagram
        </mat-checkbox>
      </section>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button class="btn btn--transparent" tabindex="-1" [mat-dialog-close]="">
      {{ "shared.cancel" | translate }}
    </button>
    <button
      (click)="openPreviewModal()"
      class="btn btn--primary"
      [disabled]="!showPreviewButton"
    >
      {{ "brand.campaign.contentCalendarPost.previewPost" | translate }}
    </button>
    <button
      class="btn btn--primary"
      tabindex="-1"
      (click)="onSaveContent()"
      [disabled]="checkSaveDisabled()"
    >
      <span *ngIf="saving">{{ "shared.saving" | translate }}</span>
      <span *ngIf="!saving">{{
        "brand.campaign.contentCalendarPost.savePost" | translate
      }}</span>
    </button>
  </mat-dialog-actions>
</div>
